import { render, staticRenderFns } from "./LeadUpload.vue?vue&type=template&id=1561130c&"
import script from "./LeadUpload.vue?vue&type=script&lang=ts&"
export * from "./LeadUpload.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports